
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';;

import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class VehicleEntryCarrierService extends Baseservice {

  constructor(http:HttpClient,authentication:AuthenticationService) {
    super("vehicle-entry-carrier",http,authentication)
   }
   postVehicleEntryCarrier(object : any) {
    let body = object;
    return this.http.post(this.url,body);

  }
  getVehicleEntryCarrier(id) {
    return this.http.get(this.url+'/'+id);

  }

}
